<div class="home-page flex-direction-column">
  <header class="home-topbar">
    <button type="button" class="home-topbar-menu" (click)="abrirMenuMobile()" aria-label="Abrir menu">
      <img src="./assets/icones/redesign/header/header-menu-open.svg" alt="" />
    </button>
    <span class="home-topbar-titulo">Início</span>
    <img src="./assets/clari-talk-logo-texto.png" alt="ClariTalk" class="home-topbar-logo" />
  </header>

  <div class="home-inner page-redesign flex-direction-column">
    <div class="home-saudacao">
      <span class="home-saudacao-texto">Olá, {{ usuarioLogado?.nome || 'Bem-vindo' }}</span>
    </div>

    <div class="home-conteudo flex-direction-column">
    <section class="home-banner">
      <div class="home-banner-textos">
        <div class="home-banner-desktop">
          <h1 class="home-banner-titulo">Bem-vindo ao Claritalk!</h1>
          <p class="home-banner-desc">Este ambiente foi desenvolvido para oferecer uma experiência simples, intuitiva e eficiente, conectando você rapidamente aos recursos e soluções de que precisa. Explore as funcionalidades, aproveite as ferramentas disponíveis e conte com nosso suporte sempre que necessário. Estamos felizes em ter você aqui!</p>
          <button type="button" class="home-banner-btn" (click)="irParaChat()">Começar agora</button>
        </div>
        <div class="home-banner-mobile">
          <h1 class="home-banner-titulo-mobile">Olá, {{ primeiroNome }} 👋</h1>
          <p class="home-banner-desc-mobile">Bem-vindo de volta. Aqui está o resumo do seu dia.</p>
        </div>
      </div>
      <img class="home-banner-img" src="./assets/clari-avatar.png" alt="" />
    </section>

    @if (carregandoLembretes || lembretesHoje > 0) {
      <section class="home-alerta" role="button" tabindex="0" (click)="irParaLembretes()" (keydown.enter)="irParaLembretes()">
        <span class="home-alerta-icone-fundo">
          <img src="./assets/icones/redesign/modulos/lembretes/icon-signal-lembrete.svg" alt="" class="home-alerta-icone" />
        </span>
        <div class="home-alerta-textos">
          @if (carregandoLembretes) {
            <span class="skeleton home-alerta-skeleton-titulo"></span>
            <span class="skeleton home-alerta-skeleton-sub"></span>
          } @else {
            <span class="home-alerta-titulo home-alerta-titulo-desktop">
              {{ lembretesHoje === 1 ? 'Você tem 1 lembrete para hoje' : 'Você tem ' + lembretesHoje + ' lembretes para hoje' }}
            </span>
            <span class="home-alerta-titulo home-alerta-titulo-mobile">
              {{ lembretesHoje === 1 ? '1 lembrete para hoje' : lembretesHoje + ' lembretes para hoje' }}
            </span>
            <span class="home-alerta-sub-desktop">Acompanhe seus lembretes antes que o dia termine.</span>
            <span class="home-alerta-sub-mobile">Toque para acompanhar</span>
          }
        </div>
        <button type="button" class="home-alerta-btn" (click)="$event.stopPropagation(); irParaLembretes()">
          <span>Ver lembretes</span>
          <span class="home-icone-mask home-mask-seta home-alerta-btn-seta"></span>
        </button>
        <span class="home-icone-mask home-mask-chevron home-alerta-chevron"></span>
      </section>
    }

    <div class="home-grid">
      <div class="home-coluna-esquerda">
        <div class="home-chat">
          <button type="button" class="home-chat-desktop" (click)="irParaChat()">
            <span class="home-chat-icone-fundo">
              <span class="home-icone-mask home-mask-chat home-chat-icone"></span>
            </span>
            <span class="home-chat-titulo">Ir para Chat</span>
            <span class="home-chat-sub">Atenda as conversas que estão na fila.</span>
          </button>
          <button type="button" class="home-chat-mobile" (click)="irParaChat()">
            <span class="home-chat-icone-fundo">
              <span class="home-icone-mask home-mask-chat home-chat-icone"></span>
            </span>
            <div class="home-chat-mobile-textos">
              <span class="home-chat-titulo">Ir para o Chat</span>
              <span class="home-chat-sub">
                {{ carregandoMetricas ? '—' : qtd.qtdFilaEspera }} {{ qtd.qtdFilaEspera === 1 ? 'conversa na fila' : 'conversas na fila' }}
              </span>
            </div>
            <span class="home-icone-mask home-mask-seta home-chat-mobile-seta"></span>
          </button>
        </div>

        <div class="home-fila">
          <span class="home-fila-titulo">Fila &amp; Lembretes</span>
          <div class="home-fila-lista">
            <div class="home-fila-item">
              <span class="home-fila-icone-fundo" style="background-color:#EEF1FE">
                <span class="home-icone-mask home-mask-fila" style="background-color:#3B5BDB"></span>
              </span>
              <span class="home-fila-label">Fila de Espera</span>
              @if (carregandoMetricas) {
                <span class="skeleton home-fila-badge-skeleton"></span>
              } @else {
                <span class="home-fila-badge" style="background-color:#EEF1FE; color:#3B5BDB">{{ qtd.qtdFilaEspera }}</span>
              }
            </div>
            <div class="home-fila-item">
              <span class="home-fila-icone-fundo" style="background-color:#F3E9FE">
                <span class="home-icone-mask home-mask-relogio" style="background-color:var(--primary)"></span>
              </span>
              <span class="home-fila-label">Tempo médio na fila</span>
              @if (carregandoMetricas) {
                <span class="skeleton home-fila-badge-skeleton"></span>
              } @else {
                <span class="home-fila-badge" style="background-color:#F3E9FE; color:var(--primary)">{{ qtd.tempoMedioFilaEspera }}h</span>
              }
            </div>
            <div class="home-fila-item">
              <span class="home-fila-icone-fundo" style="background-color:#FFF6E0">
                <span class="home-icone-mask home-mask-bell" style="background-color:#C99A1E"></span>
              </span>
              <span class="home-fila-label">Lembretes hoje</span>
              @if (carregandoLembretes) {
                <span class="skeleton home-fila-badge-skeleton"></span>
              } @else {
                <span class="home-fila-badge" style="background-color:#FFF6E0; color:#C99A1E">{{ lembretesHoje }}</span>
              }
            </div>
          </div>
        </div>
      </div>

      <div class="home-metricas">
        @for (m of metricas; track m.label) {
          <div class="home-metrica-card">
            <span class="home-metrica-icone-fundo" [style.backgroundColor]="m.corFundo">
              <span [class]="'home-icone-mask ' + m.mask" [style.backgroundColor]="m.cor"></span>
            </span>
            @if (carregandoMetricas) {
              <span class="skeleton home-metrica-skeleton"></span>
            } @else {
              <span class="home-metrica-valor">{{ m.valor }}</span>
            }
            <span class="home-metrica-label home-metrica-label-desktop">{{ m.label }}</span>
            <span class="home-metrica-label home-metrica-label-mobile">{{ m.labelCurto }}</span>
          </div>
        }
      </div>
    </div>
  </div>
  </div>
</div>
